export const NAME = 'ARTICLES';

export const articleCategories = (store) => store[NAME].categories.data;
export const isArticleCategoriesCacheExpired = (store) =>
  new Date().getTime() > store[NAME].categories.exp;
export const articlePageMeta = (store) => store[NAME].list.page;
export const getPaginatedArticles = (store) => store[NAME].list.data;
export const defaultArticles = (store) => store[NAME].list.default;
